import { apiRequest } from "services/toDoService";
import { processErrorResponse } from 'utils/errorHandler';


export const getToDoList = (params) => async (dispatch) => {

    if (!params.silent) {
        dispatch({ type: "TO_DO_LOADING" });
    }

    try {
        // Remove silent from query params
        const { silent, ...queryParams } = params;
        const query = queryParams ? `?${new URLSearchParams(queryParams).toString()}` : "";

        // Add silent header if silent is true
        const options = silent ? {
            headers: {
                'X-Silent-Request': 'true'
            }
        } : {};

        const data = await apiRequest(`workitems${query}`, "GET", null, options);
        dispatch({ type: "TO_DO_SUCCESS", payload: data });
    } catch (error) {
        dispatch({ type: "TO_DO_ERROR", payload: error.message });
        processErrorResponse(error);
    }
};